<template>
  <div class="base-layout-cards">
    <div class="content">
      <slot />
    </div>
    <BaseFiller class="filler" />
  </div>
</template>

<script>
import BaseFiller from '@/components/BaseFiller/BaseFiller'
export default {
  components: {
    BaseFiller
  }
}
</script>

<style lang="scss" scoped>
.base-layout-cards {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: var(--spacing-5);
  @include media(sm-down) {
    grid-template-columns: 1fr;
  }
}
.content {
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
.filler {
  @include media(sm-down) {
    display: none;
  }
}
</style>
